var map = {
	"./template.bet777": 1952,
	"./template.bet777.tsx": 1952,
	"./template.betgalaxy": 1953,
	"./template.betgalaxy.tsx": 1953,
	"./template.betprofessor": 1976,
	"./template.betprofessor.tsx": 1976,
	"./template.buffalobet": 1954,
	"./template.buffalobet.tsx": 1954,
	"./template.default": 142,
	"./template.default.tsx": 142,
	"./template.forsport": 1955,
	"./template.forsport.tsx": 1955,
	"./template.gigabet": 1956,
	"./template.gigabet.tsx": 1956,
	"./template.goldenbet888": 1957,
	"./template.goldenbet888.tsx": 1957,
	"./template.goldenrush": 1958,
	"./template.goldenrush.tsx": 1958,
	"./template.juicybet": 1959,
	"./template.juicybet.tsx": 1959,
	"./template.magnumbet": 1960,
	"./template.magnumbet.tsx": 1960,
	"./template.oldgill": 2046,
	"./template.oldgill.tsx": 2046,
	"./template.puntgenie": 1977,
	"./template.puntgenie.tsx": 1977,
	"./template.pyramidbet": 1961,
	"./template.pyramidbet.tsx": 1961,
	"./template.slambet": 1962,
	"./template.slambet.tsx": 1962,
	"./template.sterlingparker": 1963,
	"./template.sterlingparker.tsx": 1963,
	"./template.templebet": 1964,
	"./template.templebet.tsx": 1964,
	"./template.titanbet": 1965,
	"./template.titanbet.tsx": 1965,
	"./template.ts": 997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2801;